import { useLocation } from 'react-router-dom';
import SurveyForm from './survey/SurveyForm';

interface Props {
  isAffiliate?: boolean;
}

export default function SurveySection({ isAffiliate = false }: Props) {
  const location = useLocation();
  const isAffiliateRoute = location.pathname === '/affiliate';

  return (
    <section
      id="survey-form-section"
      className="survey-section-bg"
      data-track-view="view_survey"
      data-element-name="survey_section"
      style={{
        position: 'relative',
        padding: '48px 16px 64px',
      }}
    >
      <div style={{ maxWidth: '480px', margin: '0 auto' }}>
        {/* Title */}
        <div style={{ textAlign: 'center', marginBottom: '24px' }}>
          <p
            style={{
              fontWeight: 700,
              fontSize: '16px',
              color: '#222',
              marginBottom: isAffiliateRoute ? 0 : '6px',
            }}
          >
            ＼ まずはアンケートに回答してください ／
          </p>
          {!isAffiliateRoute && (
            <p style={{ fontWeight: 700, fontSize: '13px', color: '#444' }}>
              ＼ 情報収集だけでもOKです ／
            </p>
          )}
        </div>

        <SurveyForm isAffiliate={isAffiliate} />
      </div>
    </section>
  );
}
